export default __webpack_public_path__ + "static/media/QualityAssurance.35425a4a.svg";